var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { PremiseType } from '@/common/types/PremiseType';
import LabelControl from "@/common/components/LabelControl.vue";
import PlainTextControl from "@/common/components/PlainTextControl.vue";
import TextAreaRow from "@/common/components/TextAreaRow.vue";
import CheckBoxListRow from "@/common/components/CheckBoxListRow.vue";
import PremisesTableControl from '@/template/components/aidapplication/controls/PremisesTableControl.vue';
import { Owner } from '@/common/types/Owner';
import { Premises } from '@/common/types/Premises';
import { Savable } from '@/common/mixins/Savable';
import { Focusable } from '@/common/mixins/Focusable';
var PremisesControl = /** @class */ (function (_super) {
    __extends(PremisesControl, _super);
    function PremisesControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkBoxValuesChanged = "";
        return _this;
    }
    PremisesControl.prototype.mounted = function () {
        this.$emit("expense-changed", this.calculatePremiseTotalExpenses());
    };
    PremisesControl.prototype.onPremiseTypesChanged = function () {
        if (this.showOwnPremises) {
            if (this.ownPremises.length === 0)
                this.addOwnPremise(false);
        }
        else
            this.ownPremises = [];
        if (this.showRentalPremises) {
            if (this.rentalPremises.length === 0)
                this.addRentalPremise(false);
        }
        else
            this.rentalPremises = [];
        if (this.showRelatedPremises) {
            if (this.relatedPremises.length === 0)
                this.addRelatedPremise(false);
        }
        else
            this.relatedPremises = [];
        if (!this.showOtherPremises)
            this.premises.otherPremises = null;
    };
    PremisesControl.prototype.onOwnPremisesChanged = function () {
        this.$emit("expense-changed", this.calculatePremiseTotalExpenses());
    };
    PremisesControl.prototype.onRentalPremisesChanged = function () {
        this.$emit("expense-changed", this.calculatePremiseTotalExpenses());
    };
    PremisesControl.prototype.onRelatedPremisesChanged = function () {
        this.$emit("expense-changed", this.calculatePremiseTotalExpenses());
    };
    Object.defineProperty(PremisesControl.prototype, "premiseTypes", {
        get: function () {
            return this.premises.premiseTypes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "premisesOptions", {
        get: function () {
            return [
                { id: PremiseType.OwnPremises, name: "BudgetaryEstimate.Premises.PremiseTypes.OwnPremises", confirmCheckboxClean: this.cleanOwnPremises },
                { id: PremiseType.RelatedOrganisationPremises, name: "BudgetaryEstimate.Premises.PremiseTypes.RelatedOrganisationPremises", confirmCheckboxClean: this.cleanRelatedPremises },
                { id: PremiseType.Rental, name: "BudgetaryEstimate.Premises.PremiseTypes.Rental", confirmCheckboxClean: this.cleanRentalPremises },
                { id: PremiseType.MunicipalityPremises, name: "BudgetaryEstimate.Premises.PremiseTypes.MunicipalityPremises", confirmCheckboxClean: function () { return true; } },
                { id: PremiseType.Other, name: "BudgetaryEstimate.Premises.PremiseTypes.Other", confirmCheckboxClean: this.cleanOtherPremises }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PremisesControl.prototype.cleanOwnPremises = function () {
        if (this.ownPremises.length > 0) {
            if (this.firstPremiseNotEmpty(this.ownPremises[0]) || this.ownPremises.length > 1) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Premises.Own").toString())) {
                    this.ownPremises = [];
                    return true;
                }
            }
            else if (this.ownPremises.length == 1) {
                return true;
            }
            this.premiseTypes.push(PremiseType.OwnPremises);
            this.checkBoxValuesChanged = Date();
            return false;
        }
        return true;
    };
    PremisesControl.prototype.cleanRelatedPremises = function () {
        if (this.relatedPremises.length > 0) {
            if (this.firstPremiseNotEmpty(this.relatedPremises[0]) || this.relatedPremises.length > 1) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Premises.Related").toString())) {
                    this.relatedPremises = [];
                    return true;
                }
            }
            else if (this.relatedPremises.length == 1) {
                return true;
            }
            this.premiseTypes.push(PremiseType.RelatedOrganisationPremises);
            this.checkBoxValuesChanged = Date();
            return false;
        }
        return true;
    };
    PremisesControl.prototype.cleanRentalPremises = function () {
        if (this.rentalPremises.length > 0) {
            if (this.firstPremiseNotEmpty(this.rentalPremises[0]) || this.rentalPremises.length > 1) {
                if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Premises.Rental").toString())) {
                    this.rentalPremises = [];
                    return true;
                }
            }
            else if (this.rentalPremises.length == 1) {
                return true;
            }
            this.premiseTypes.push(PremiseType.Rental);
            this.checkBoxValuesChanged = Date();
            return false;
        }
        return true;
    };
    PremisesControl.prototype.cleanOtherPremises = function () {
        if (this.otherPremises) {
            if (confirm(this.$i18n.t("AidApplication.Confirm.Delete.Premises.Other").toString())) {
                this.otherPremises = "";
                return true;
            }
            this.premiseTypes.push(PremiseType.Other);
            this.checkBoxValuesChanged = Date();
            return false;
        }
        return true;
    };
    PremisesControl.prototype.firstPremiseNotEmpty = function (premise) {
        var e_1, _a;
        try {
            for (var _b = __values(premise.yearlyData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var yearData = _c.value;
                if (yearData.name
                    || (yearData.costs || yearData.costs == 0)
                    || (yearData.area || yearData.area == 0)
                    || yearData.owner
                    || yearData.postalCode
                    || (yearData.otherCosts || yearData.otherCosts == 0))
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    Object.defineProperty(PremisesControl.prototype, "ownerOptions", {
        get: function () {
            return [
                { id: Owner.PrivatePerson, name: "BudgetaryEstimate.Premises.RentalPremises.Owner.PrivatePerson" },
                { id: Owner.Community, name: "BudgetaryEstimate.Premises.RentalPremises.Owner.Community" },
                { id: Owner.PrivatePersonOrRelatedParty, name: "BudgetaryEstimate.Premises.RentalPremises.Owner.PrivatePersonOrRelatedParty" },
                { id: Owner.CommunityOrRelatedParty, name: "BudgetaryEstimate.Premises.RentalPremises.Owner.CommunityOrRelatedParty" },
                { id: Owner.Unknown, name: "BudgetaryEstimate.Premises.RentalPremises.Owner.Unknown" }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "ownPremisesColumns", {
        get: function () {
            return [
                "Year",
                "BudgetaryEstimate.Premises.OwnPremises.Columns.Owner",
                "BudgetaryEstimate.Premises.OwnPremises.Columns.MaintenanceFee",
                "BudgetaryEstimate.Premises.OwnPremises.Columns.OtherCosts",
                "BudgetaryEstimate.Premises.OwnPremises.Columns.Area",
                "BudgetaryEstimate.Premises.OwnPremises.Columns.PostalCode"
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "relatedPremisesColumns", {
        get: function () {
            return [
                "Year",
                "BudgetaryEstimate.Premises.RelatedPremises.Columns.Owner",
                "BudgetaryEstimate.Premises.RelatedPremises.Columns.MaintenanceFee",
                "BudgetaryEstimate.Premises.RelatedPremises.Columns.OtherCosts",
                "BudgetaryEstimate.Premises.RelatedPremises.Columns.Area",
                "BudgetaryEstimate.Premises.RelatedPremises.Columns.PostalCode"
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "rentalPremisesColumns", {
        get: function () {
            return [
                "Year",
                "BudgetaryEstimate.Premises.RentalPremises.Columns.Owner",
                "BudgetaryEstimate.Premises.RentalPremises.Columns.Rent",
                "BudgetaryEstimate.Premises.RentalPremises.Columns.OtherCosts",
                "BudgetaryEstimate.Premises.RentalPremises.Columns.Area",
                "BudgetaryEstimate.Premises.RentalPremises.Columns.PostalCode"
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "showOwnPremises", {
        get: function () {
            return this.premiseTypes != null && this.premiseTypes.some(function (x) { return x === PremiseType.OwnPremises; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "showRelatedPremises", {
        get: function () {
            return this.premiseTypes != null && this.premiseTypes.some(function (x) { return x === PremiseType.RelatedOrganisationPremises; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "showRentalPremises", {
        get: function () {
            return this.premiseTypes != null && this.premiseTypes.some(function (x) { return x === PremiseType.Rental; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "showOtherPremises", {
        get: function () {
            return this.premiseTypes != null && this.premiseTypes.some(function (x) { return x === PremiseType.Other; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "isOwnPremisesBtnDisabled", {
        get: function () {
            return this.premises.ownPremises.length === 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "isRelatedPremisesBtnDisabled", {
        get: function () {
            return this.premises.relatedPremises.length === 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "isRentalPremisesBtnDisabled", {
        get: function () {
            return this.premises.rentalPremises.length === 10;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "ownPremises", {
        get: function () {
            return this.premises.ownPremises;
        },
        set: function (value) {
            this.premises.ownPremises = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "relatedPremises", {
        get: function () {
            return this.premises.relatedPremises;
        },
        set: function (value) {
            this.premises.relatedPremises = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "rentalPremises", {
        get: function () {
            return this.premises.rentalPremises;
        },
        set: function (value) {
            this.premises.rentalPremises = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesControl.prototype, "otherPremises", {
        get: function () {
            return this.premises.otherPremises;
        },
        set: function (value) {
            this.premises.otherPremises = value;
        },
        enumerable: false,
        configurable: true
    });
    PremisesControl.prototype.getOwnPremisesTableTitle = function (index) {
        return this.$t("BudgetaryEstimate.Premises.OwnPremises.Table_Title", [index + 1]).toString();
    };
    PremisesControl.prototype.getRelatedPremisesTableTitle = function (index) {
        return this.$t("BudgetaryEstimate.Premises.RelatedPremises.Table_Title", [index + 1]).toString();
    };
    PremisesControl.prototype.getRentalPremisesTableTitle = function (index) {
        return this.$t("BudgetaryEstimate.Premises.RentalPremises.Table_Title", [index + 1]).toString();
    };
    PremisesControl.prototype.showOwnPremisesDeleteBtn = function () {
        return this.ownPremises && this.ownPremises.length > 1;
    };
    PremisesControl.prototype.showRelatedPremisesDeleteBtn = function () {
        return this.ownPremises && this.relatedPremises.length > 1;
    };
    PremisesControl.prototype.showRentalPremisesDeleteBtn = function () {
        return this.rentalPremises && this.rentalPremises.length > 1;
    };
    PremisesControl.prototype.deleteOwnPremisesTable = function (index) {
        if (confirm(this.$i18n.t("Confirmation.DeletePremisesTable").toString())) {
            this.ownPremises.splice(index, 1);
            this.forceSave();
        }
    };
    PremisesControl.prototype.deleteRelatedPremisesTable = function (index) {
        if (confirm(this.$i18n.t("Confirmation.DeletePremisesTable").toString())) {
            this.relatedPremises.splice(index, 1);
            this.forceSave();
        }
    };
    PremisesControl.prototype.deleteRentalPremisesTable = function (index) {
        if (confirm(this.$i18n.t("Confirmation.DeletePremisesTable").toString())) {
            this.rentalPremises.splice(index, 1);
            this.forceSave();
        }
    };
    PremisesControl.prototype.addOwnPremise = function (focus) {
        return __awaiter(this, void 0, void 0, function () {
            var targetClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ownPremises.push(this.createPremiseData());
                        this.forceSave();
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetClass = "own-premise-" + this.ownPremises.length;
                        if (focus)
                            this.focusOnComponentClass(targetClass);
                        return [2 /*return*/];
                }
            });
        });
    };
    PremisesControl.prototype.addRelatedPremise = function (focus) {
        return __awaiter(this, void 0, void 0, function () {
            var targetClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.relatedPremises.push(this.createPremiseData());
                        this.forceSave();
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetClass = "related-premise-" + this.relatedPremises.length;
                        if (focus)
                            this.focusOnComponentClass(targetClass);
                        return [2 /*return*/];
                }
            });
        });
    };
    PremisesControl.prototype.addRentalPremise = function (focus) {
        return __awaiter(this, void 0, void 0, function () {
            var targetClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.rentalPremises.push(this.createPremiseData());
                        this.forceSave();
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _a.sent();
                        targetClass = "rental-premise-" + this.rentalPremises.length;
                        if (focus)
                            this.focusOnComponentClass(targetClass);
                        return [2 /*return*/];
                }
            });
        });
    };
    PremisesControl.prototype.createPremiseData = function () {
        if (typeof (this.createPremise) == "function") {
            return this.createPremise();
        }
        else {
            return this.createYearlyData();
        }
    };
    PremisesControl.prototype.createYearlyData = function () {
        var year = this.applicationYear;
        var item = { yearlyData: [] };
        item.yearlyData.push({ year: year, name: null, owner: null, postalCode: null, area: null, costs: null, otherCosts: null });
        item.yearlyData.push({ year: year + 1, name: null, owner: null, postalCode: null, area: null, costs: null, otherCosts: null });
        item.yearlyData.push({ year: year + 2, name: null, owner: null, postalCode: null, area: null, costs: null, otherCosts: null });
        return item;
    };
    PremisesControl.prototype.calculatePremiseTotalExpenses = function () {
        var totals = [];
        if (this.applicationYear) {
            for (var year = this.applicationYear; year < this.applicationYear + 3; year++) {
                var ownPremisesTotal = this.calculatePremisesTotalForYear(year, this.ownPremises);
                var relatedPremisesTotal = this.calculatePremisesTotalForYear(year, this.relatedPremises);
                var rentalPremisesTotal = this.calculatePremisesTotalForYear(year, this.rentalPremises);
                var total = ownPremisesTotal + relatedPremisesTotal + rentalPremisesTotal;
                totals.push({ year: year, total: total });
            }
        }
        return totals;
    };
    PremisesControl.prototype.calculatePremisesTotalForYear = function (year, premises) {
        var itemsForYear = premises.map(function (premise) { return premise.yearlyData.find(function (row) { return row.year === year; }); });
        return itemsForYear.reduce(function (acc, current) { return Number(acc) + (Number(current.costs || 0) + Number(current.otherCosts || 0)); }, 0) * 12;
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof Premises !== "undefined" && Premises) === "function" ? _a : Object)
    ], PremisesControl.prototype, "premises", void 0);
    __decorate([
        Prop({ type: Number, required: true }),
        __metadata("design:type", Number)
    ], PremisesControl.prototype, "applicationYear", void 0);
    __decorate([
        Prop({ type: Function, required: false }),
        __metadata("design:type", Function)
    ], PremisesControl.prototype, "createPremise", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PremisesControl.prototype, "premiseRowHeaderKey", void 0);
    __decorate([
        Prop({ type: String, required: false, default: "BudgetaryEstimate" }),
        __metadata("design:type", String)
    ], PremisesControl.prototype, "pathKey", void 0);
    __decorate([
        Watch("premiseTypes"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PremisesControl.prototype, "onPremiseTypesChanged", null);
    __decorate([
        Watch("ownPremises", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PremisesControl.prototype, "onOwnPremisesChanged", null);
    __decorate([
        Watch("rentalPremises", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PremisesControl.prototype, "onRentalPremisesChanged", null);
    __decorate([
        Watch("relatedPremises", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PremisesControl.prototype, "onRelatedPremisesChanged", null);
    PremisesControl = __decorate([
        Component({
            name: "PremisesControl",
            components: {
                LabelControl: LabelControl,
                PlainTextControl: PlainTextControl,
                TextAreaRow: TextAreaRow,
                CheckBoxListRow: CheckBoxListRow,
                PremisesTableControl: PremisesTableControl,
                ValidationProvider: ValidationProvider
            }
        })
    ], PremisesControl);
    return PremisesControl;
}(Mixins(Focusable, Savable)));
export default PremisesControl;
